import { render, staticRenderFns } from "./Talent-datas.vue?vue&type=template&id=c0f53046&scoped=true&"
import script from "./Talent-datas.vue?vue&type=script&lang=js&"
export * from "./Talent-datas.vue?vue&type=script&lang=js&"
import style0 from "./assets/datas.less?vue&type=style&index=0&id=c0f53046&scoped=true&lang=less&"
import style1 from "./Talent-datas.vue?vue&type=style&index=1&id=c0f53046&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f53046",
  null
  
)

export default component.exports